// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadProcess_container__vA6xT {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.UploadProcess_header__U7s0V {
  background-color: #1053ad;
  padding: 16px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.UploadProcess_headerContent__ixYpp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}
.UploadProcess_headerContent__ixYpp h1 {
  color: white;
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  flex: 1 1;
}

.UploadProcess_backButton__WLH0I {
  background: transparent;
  border: 2px solid white;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}
.UploadProcess_backButton__WLH0I:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.UploadProcess_content__X2ucg {
  flex: 1 1;
  padding: 20px;
  display: flex;
  justify-content: center;
}

.UploadProcess_formContainer__u88FZ {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
}

.UploadProcess_form__ZJI8t {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.UploadProcess_formGroup__3QhOs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.UploadProcess_formGroup__3QhOs label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}
.UploadProcess_formGroup__3QhOs input, .UploadProcess_formGroup__3QhOs select, .UploadProcess_formGroup__3QhOs textarea {
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  font-family: inherit;
}
.UploadProcess_formGroup__3QhOs input:focus, .UploadProcess_formGroup__3QhOs select:focus, .UploadProcess_formGroup__3QhOs textarea:focus {
  outline: none;
  border-color: #1053ad;
  box-shadow: 0 0 0 3px rgba(16, 83, 173, 0.1);
}
.UploadProcess_formGroup__3QhOs input::placeholder, .UploadProcess_formGroup__3QhOs select::placeholder, .UploadProcess_formGroup__3QhOs textarea::placeholder {
  color: #999;
}
.UploadProcess_formGroup__3QhOs select {
  cursor: pointer;
}
.UploadProcess_formGroup__3QhOs textarea {
  resize: vertical;
  min-height: 80px;
}

.UploadProcess_buttonGroup__6N6sX {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.UploadProcess_cancelButton__w6vC5, .UploadProcess_submitButton__Rb4nR {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}
.UploadProcess_cancelButton__w6vC5:hover, .UploadProcess_submitButton__Rb4nR:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.UploadProcess_cancelButton__w6vC5 {
  background-color: #f5f5f5;
  color: #666;
  border: 2px solid #e0e0e0;
}
.UploadProcess_cancelButton__w6vC5:hover {
  background-color: #e0e0e0;
  color: #333;
}

.UploadProcess_submitButton__Rb4nR {
  background-color: #4caf50;
  color: white;
}
.UploadProcess_submitButton__Rb4nR:hover {
  background-color: #45a049;
}

@media (max-width: 768px) {
  .UploadProcess_headerContent__ixYpp h1 {
    font-size: 20px;
  }
  .UploadProcess_content__X2ucg {
    padding: 15px;
  }
  .UploadProcess_formContainer__u88FZ {
    padding: 20px;
  }
  .UploadProcess_buttonGroup__6N6sX {
    flex-direction: column;
    gap: 12px;
  }
  .UploadProcess_buttonGroup__6N6sX .UploadProcess_cancelButton__w6vC5, .UploadProcess_buttonGroup__6N6sX .UploadProcess_submitButton__Rb4nR {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/UploadProcess/index.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AACJ;;AAGA;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAAF;AAEE;EACE,0CAAA;EACA,2BAAA;AAAJ;;AAIA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;AAGE;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AADJ;AAIE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAFJ;AAII;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAFN;AAKI;EACE,WAAA;AAHN;AAOE;EACE,eAAA;AALJ;AAQE;EACE,gBAAA;EACA,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAPF;;AAUA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAPF;AASE;EACE,2BAAA;EACA,0CAAA;AAPJ;;AAWA;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;AARF;AAUE;EACE,yBAAA;EACA,WAAA;AARJ;;AAYA;EACE,yBAAA;EACA,YAAA;AATF;AAWE;EACE,yBAAA;AATJ;;AAcA;EAEI;IACE,eAAA;EAZJ;EAgBA;IACE,aAAA;EAdF;EAiBA;IACE,aAAA;EAfF;EAkBA;IACE,sBAAA;IACA,SAAA;EAhBF;EAkBE;IACE,WAAA;EAhBJ;AACF","sourcesContent":[".container {\n  width: 100%;\n  min-height: 100vh;\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  background-color: #1053ad;\n  padding: 16px 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.headerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  h1 {\n    color: white;\n    margin: 0;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    flex: 1;\n  }\n}\n\n.backButton {\n  background: transparent;\n  border: 2px solid white;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    transform: translateY(-1px);\n  }\n}\n\n.content {\n  flex: 1;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.formContainer {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 800px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  label {\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n  }\n\n  input, select, textarea {\n    padding: 12px;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    font-size: 14px;\n    transition: all 0.3s ease;\n    font-family: inherit;\n\n    &:focus {\n      outline: none;\n      border-color: #1053ad;\n      box-shadow: 0 0 0 3px rgba(16, 83, 173, 0.1);\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n\n  select {\n    cursor: pointer;\n  }\n\n  textarea {\n    resize: vertical;\n    min-height: 80px;\n  }\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancelButton, .submitButton {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.cancelButton {\n  background-color: #f5f5f5;\n  color: #666;\n  border: 2px solid #e0e0e0;\n\n  &:hover {\n    background-color: #e0e0e0;\n    color: #333;\n  }\n}\n\n.submitButton {\n  background-color: #4caf50;\n  color: white;\n\n  &:hover {\n    background-color: #45a049;\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .headerContent {\n    h1 {\n      font-size: 20px;\n    }\n  }\n\n  .content {\n    padding: 15px;\n  }\n\n  .formContainer {\n    padding: 20px;\n  }\n\n  .buttonGroup {\n    flex-direction: column;\n    gap: 12px;\n\n    .cancelButton, .submitButton {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UploadProcess_container__vA6xT`,
	"header": `UploadProcess_header__U7s0V`,
	"headerContent": `UploadProcess_headerContent__ixYpp`,
	"backButton": `UploadProcess_backButton__WLH0I`,
	"content": `UploadProcess_content__X2ucg`,
	"formContainer": `UploadProcess_formContainer__u88FZ`,
	"form": `UploadProcess_form__ZJI8t`,
	"formGroup": `UploadProcess_formGroup__3QhOs`,
	"buttonGroup": `UploadProcess_buttonGroup__6N6sX`,
	"cancelButton": `UploadProcess_cancelButton__w6vC5`,
	"submitButton": `UploadProcess_submitButton__Rb4nR`
};
export default ___CSS_LOADER_EXPORT___;
